import React from 'react';
import StatisticsCard from './StatisticsCard';

const StatisticsDashboard = () => {
    const statistics = [
        {value: "121", label: 'Public cloud accounts created'},
        {value: "$750K", label: 'Saved via monthly reductions'},
        {value: "60", label: 'Fewer incidents per month'},
        {value: "458", label: 'Managed public cloud accounts'}
    ];
    
    return (
        <div className="row">
            {statistics.map((stat,index) => (
                <div className="col-md-6 mb-3" key={index}>
                    <StatisticsCard value={stat.value} label={stat.label} />
                </div>
            ))}
        </div>
    );
};

export default StatisticsDashboard;